module.exports = __webpack_public_path__ + "static/media/logo.d89a1bd7.png";